import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row block agency-details" }
const _hoisted_2 = {
  key: 0,
  class: "col col-auto me-4"
}
const _hoisted_3 = { class: "agency-definition-list" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "col col-auto me-4 mt-4"
}
const _hoisted_7 = { class: "agency-definition-list" }
const _hoisted_8 = {
  key: 2,
  class: "col col-auto staffing me-4 mt-4"
}
const _hoisted_9 = { class: "agency-definition-list" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "row block contacts" }

import {BCard} from "./../Misc";
import {formatNumber} from "@/utils";
import AgencyOverviewContact from "./AgencyOverviewContact.vue";
import {computed, watch} from "vue";
import {useOriStore} from "@/stores/oriStore";
import hasPermission from "@/composable/permissionHelper";
import {storeToRefs} from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'AgencyOverview',
  props: {
    ori: {
        type: String,
        default: null,
    },
},
  setup(__props) {

const props = __props;

const oriStore = useOriStore();
var {population, staffing} = storeToRefs(useOriStore());

const data = computed(() => {
    return oriStore.ori;
});

const hasContacts = computed(() => {
    return data.value?.admin_name || data.value?.ucr_name || data.value?.comm_name;
});

watch(props, async () => {
    await oriStore.getPopulation(props.ori);
    await oriStore.getStaffing(props.ori);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BCard), { header: "Agency Overview" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_unref(hasPermission)('ViewAgencyDetails'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("dl", _hoisted_3, [
                  _cache[0] || (_cache[0] = _createElementVNode("dt", null, "Address:", -1)),
                  (data.value?.loc_street && data.value?.loc_town)
                    ? (_openBlock(), _createElementBlock("dd", _hoisted_4, [
                        _createElementVNode("div", null, _toDisplayString(data.value?.loc_street), 1),
                        _createElementVNode("div", null, _toDisplayString(data.value?.loc_town) + ", " + _toDisplayString(data.value?.loc_state), 1),
                        _createElementVNode("div", null, _toDisplayString(data.value?.loc_zip), 1)
                      ]))
                    : (data.value?.mail_street && data.value?.mail_town)
                      ? (_openBlock(), _createElementBlock("dd", _hoisted_5, [
                          _createElementVNode("div", null, _toDisplayString(data.value?.mail_street), 1),
                          _createElementVNode("div", null, _toDisplayString(data.value?.mail_town) + ", " + _toDisplayString(data.value?.mail_state), 1),
                          _createElementVNode("div", null, _toDisplayString(data.value?.mail_zip), 1)
                        ]))
                      : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(population) && _unref(population)?.year > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("dl", _hoisted_7, [
                  _createElementVNode("dt", null, _toDisplayString(_unref(population)?.year) + " Population:", 1),
                  _createElementVNode("dd", null, _toDisplayString(_unref(formatNumber)(_unref(population)?.employee_population)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(staffing) &&
                    (_unref(staffing).year > 0 ||
                        _unref(staffing).sworn_in_male ||
                        _unref(staffing).sworn_in_female ||
                        _unref(staffing).civilian_male ||
                        _unref(staffing).civilian_female))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("dl", _hoisted_9, [
                  (_unref(staffing).year > 0)
                    ? (_openBlock(), _createElementBlock("dt", _hoisted_10, _toDisplayString(_unref(staffing).year) + " Employee Count", 1))
                    : _createCommentVNode("", true),
                  (_unref(staffing).year > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_unref(staffing).sworn_in_male)
                          ? (_openBlock(), _createElementBlock("dd", _hoisted_11, [
                              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "definition-label" }, "Sworn-in Male:", -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(formatNumber)(_unref(staffing).sworn_in_male)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(staffing).sworn_in_female)
                          ? (_openBlock(), _createElementBlock("dd", _hoisted_12, [
                              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "definition-label" }, "Sworn-in Female:", -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(formatNumber)(_unref(staffing).sworn_in_female)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(staffing).civilian_male)
                          ? (_openBlock(), _createElementBlock("dd", _hoisted_13, [
                              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "definition-label" }, "Civilian Male:", -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(formatNumber)(_unref(staffing).civilian_male)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(staffing).civilian_female)
                          ? (_openBlock(), _createElementBlock("dd", _hoisted_14, [
                              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "definition-label" }, "Civilian Female:", -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(formatNumber)(_unref(staffing).civilian_female)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_unref(hasPermission)('ViewAgencyContacts') && hasContacts.value)
      ? (_openBlock(), _createBlock(_unref(BCard), {
          key: 0,
          header: "Agency Contacts"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(AgencyOverviewContact, {
                title: data.value?.admin_title,
                name: data.value?.admin_name,
                email: data.value?.admin_email,
                phone: data.value?.admin_phone,
                fax: data.value?.admin_fax
              }, null, 8, ["title", "name", "email", "phone", "fax"]),
              _createVNode(AgencyOverviewContact, {
                title: data.value?.ucr_title,
                name: data.value?.ucr_name,
                email: data.value?.ucr_email,
                phone: data.value?.ucr_phone,
                fax: data.value?.ucr_fax
              }, null, 8, ["title", "name", "email", "phone", "fax"]),
              _createVNode(AgencyOverviewContact, {
                title: data.value?.comm_title,
                name: data.value?.comm_name,
                email: data.value?.comm_email,
                phone: data.value?.comm_phone,
                fax: data.value?.comm_fax
              }, null, 8, ["title", "name", "email", "phone", "fax"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})